import { render, staticRenderFns } from "./EditTurns.vue?vue&type=template&id=6c1aa411"
import script from "./EditTurns.vue?vue&type=script&lang=js"
export * from "./EditTurns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports